import SequenceNumberListPagingResultModelBase from '../_generated/modelBases/sequence-number-list-paging-result-model-base';

export default class SequenceNumberListPagingResultModel extends SequenceNumberListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
